import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof _Object$getOwnPropertySymbols === "function") for (var i = 0, p = _Object$getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import * as React from 'react';
import { ConfigContext } from '../config-provider';
import { getCompProps } from '../_utils';
import classNames from 'classnames';
export var Menu = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var _context;

  var _React$useContext = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext.getPrefixCls,
      pkgPrefixCls = _React$useContext.prefixCls,
      userDefaultProps = _React$useContext.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _a = getCompProps('DropdownMenu', userDefaultProps, props),
      customPrefixcls = _a.prefixCls,
      children = _a.children,
      selectable = _a.selectable,
      selectedKey = _a.selectedKey,
      className = _a.className,
      restProps = __rest(_a, ["prefixCls", "children", "selectable", "selectedKey", "className"]); // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'dropdown-menu', customPrefixcls);

  var cloneItem = function cloneItem(item, index) {
    var key = item.key || index;
    var selected = selectable && String(selectedKey) === String(key);
    return /*#__PURE__*/React.cloneElement(item, {
      key: key,
      selected: selected,
      defaultKey: key
    });
  };

  return /*#__PURE__*/React.createElement("ul", _extends({
    className: classNames(prefixCls, className),
    role: "menu"
  }, restProps, {
    ref: ref
  }), _mapInstanceProperty(_context = React.Children).call(_context, children, cloneItem));
});
export var Item = function Item(props) {
  var _a, _b;

  var _React$useContext2 = React.useContext(ConfigContext),
      getPrefixCls = _React$useContext2.getPrefixCls,
      pkgPrefixCls = _React$useContext2.prefixCls,
      userDefaultProps = _React$useContext2.compDefaultProps; // 属性需要合并一遍用户定义的默认属性


  var _c = getCompProps('DropdownItem', userDefaultProps, props),
      customPrefixcls = _c.prefixCls,
      danger = _c.danger,
      divided = _c.divided,
      disabled = _c.disabled,
      children = _c.children,
      selected = _c.selected,
      defaultKey = _c.defaultKey,
      className = _c.className,
      restProps = __rest(_c, ["prefixCls", "danger", "divided", "disabled", "children", "selected", "defaultKey", "className"]); // className前缀


  var prefixCls = getPrefixCls(pkgPrefixCls, 'dropdown-menu-item', customPrefixcls);
  var childrenIsLink = children.type === 'a';
  var linkChildren = /*#__PURE__*/React.createElement("span", null, (_a = children.props) === null || _a === void 0 ? void 0 : _a.children);
  var itemRef = React.useRef();
  return /*#__PURE__*/React.createElement("li", _extends({
    ref: itemRef,
    "data-key": defaultKey,
    title: (_b = itemRef.current) === null || _b === void 0 ? void 0 : _b.textContent,
    className: classNames(prefixCls, className, {
      danger: danger,
      divided: divided,
      disabled: disabled,
      selected: selected
    }),
    role: "menuitem"
  }, restProps), childrenIsLink ? disabled ? linkChildren : /*#__PURE__*/React.cloneElement(children, {
    children: linkChildren
  }) : /*#__PURE__*/React.createElement("span", null, children));
};